import { padding } from '@/common/style';
import React, { useState } from 'react';
import { View, Text, Modal } from 'react-native';
import { StyleSheet } from 'react-native';
import RootSiblings from 'react-native-root-siblings';
import { styles as styleFn } from '@/common/style';

const styles = StyleSheet.create({
    nonModelBox: {
        position: 'absolute',
        top: 0,
        bottom: 0,
        left: 0,
        right: 0,
    },
    centeredView: {
        flex: 1,
        justifyContent: 'center',
        alignItems: 'center',
    },
    modalView: {
        marginLeft: 20,
        marginRight: 20,
        ...padding(16, 12, 16, 12),
        backgroundColor: 'rgba(44, 44, 44, 0.72)',
        borderRadius: 8,
        alignItems: 'center',
    },
    modalText: {
        color: '#fff',
        fontSize: 16,
        fontWeight: '400',
        textAlign: 'center',
    },
});

interface IToastProps {
    visible: boolean;
    style?: any;
    content?: string;
    type?: 'success' | 'error' | 'progress' | 'info';
    useModel?: boolean;
    zIndex?: number;
}
export default function Toast(props: IToastProps) {
    const { visible = false, content, style = {}, useModel = true, zIndex = 1 } = props;
    if (useModel === false) {
        return (
            <View
                style={[
                    styles.nonModelBox,
                    styleFn({
                        zIndex,
                    }),
                ]}
                className={'toast-box'}
            >
                <View style={[styles.centeredView, style]}>
                    <View style={styles.modalView}>
                        <Text style={styles.modalText}>{content}</Text>
                    </View>
                </View>
            </View>
        );
    }
    return (
        <Modal animationType="fade" transparent={true} visible={visible}>
            <View style={[styles.centeredView, style]}>
                <View style={styles.modalView}>
                    <Text style={styles.modalText}>{content}</Text>
                </View>
            </View>
        </Modal>
    );
}

type IShowProps = { text?: string; duration?: number } & Partial<IToastProps>;
Toast.show = function (props: string | IShowProps) {
    let p = props as IShowProps;
    if (typeof props === 'string') {
        p = { useModel: true, zIndex: 1, content: props };
    }
    const slibing = new RootSiblings(<Toast zIndex={p.zIndex} useModel={p.useModel} content={p.text || p.content} visible={true} />);

    this.timer = setTimeout(() => {
        slibing.destroy();
    }, p.duration ?? 1500);
};

export function useToast() {
    const [visible, setVisible] = useState(false);
    const [content, setContent] = useState('');

    const Node = <Toast visible={visible} content={content} />;

    let timer;

    const show = (params: { text: string; duration?: number; onSuccess?: any }) => {
        return new Promise<void>((resolve, reject) => {
            const { text, duration = 1500, onSuccess = console.log } = params;
            setVisible(true);
            setContent(text);
            if (timer) {
                clearTimeout(timer);
                reject();
            }
            timer = setTimeout(() => {
                setVisible(false);
                onSuccess();
                resolve();
            }, duration);
        });
    };

    return {
        showToast: show,
        toastNode: Node,
    };
}
